module.exports = __webpack_public_path__ + "img/winner.aa018053.png";